var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCegalBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 915.85 196.25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 196.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.1)",
    fill: "#0f151c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m707.34 0c-449.75 0-707.34 294.38-707.34 729.82 0 443.62 261.68 742.1 699.16 742.1 378.21 0 605.13-222.83 643.97-531.52h-308.7c-26.57 161.5-132.88 267.8-331.18 267.8-257.59 0-394.56-190.13-394.56-474.29 0-294.38 145.15-480.41 402.74-480.41 222.83 0 312.78 145.14 339.36 318.91h308.7c-34.76-384.33-288.26-572.41-652.15-572.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1897.1 1185.7v-320.96h623.52v-245.32h-623.52v-333.22h686.9v-265.77h-991.51v1431h991.51v-265.77h-686.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5182.3 578.54-196.26 574.46-196.25-574.46zm81.77-243.27h-556.06l-108.35-314.83h-316.87l521.31 1431h363.89l519.26-1431h-314.83l-108.35 314.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6868.8 292.34v-271.9h-1007.9v1431h308.7v-1159.1h699.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3507.4 1471.9c-378.2 0-605.13-222.83-643.97-531.53h308.7c26.58 161.5 132.88 267.81 331.18 267.81 257.59 0 394.56-190.13 394.56-474.29 0-294.38-145.15-480.41-402.74-480.41-220.4 0-375.19 126.64-369.49 312.77h428.78v211.9h-707.34c0-107.2-6.63-210.66 17.22-316.22 17.14-75.859 46.17-149.38 89.98-213.88 83.42-122.83 214.67-198.61 358.18-229.39 61.31-13.148 124.12-18.68 186.76-18.68 449.76 0 707.34 294.38 707.34 729.82 0 443.62-261.67 742.1-699.16 742.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCegalBlack);
export default __webpack_public_path__ + "static/media/CegalBlack.6c3acd37377dc4c864ffdf4671780d99.svg";
export { ForwardRef as ReactComponent };